import NavList from './NavList'

export default NavList
